import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface InvitadoComite {
  id?: number;
  tipo_documento: number;
  primer_nombre: string;
  segundo_nombre: string;
  primer_apellido: string;
  segundo_apellido: string;
  telefono: number | string;
  estado?: number;
  fechacreacion?: string;
  fechamodificacion?: string;
  cc: number | string;
}

@Injectable({ providedIn: 'root' })
export class InvitadosComiteService {
  private apiUrl = `${environment.apiUrl}/api/invitados_comite`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<InvitadoComite[] | { data?: InvitadoComite[] }> {
    return this.http.get<InvitadoComite[] | { data?: InvitadoComite[] }>(this.apiUrl, {
      withCredentials: true,
    });
  }

  getById(id: number): Observable<InvitadoComite> {
    return this.http.get<InvitadoComite>(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }

  create(data: InvitadoComite): Observable<InvitadoComite> {
    return this.http.post<InvitadoComite>(this.apiUrl, data, {
      withCredentials: true,
    });
  }

  update(id: number, data: Partial<InvitadoComite>): Observable<InvitadoComite> {
    return this.http.put<InvitadoComite>(`${this.apiUrl}/${id}`, data, {
      withCredentials: true,
    });
  }

  remove(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    });
  }
}